import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

export default function Nav() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();
  const link = (to, label, testid) => (
    <Link
      to={to}
      data-testid={testid}
      className={`px-3 py-2 text-sm rounded-md hover:bg-secondary transition ${loc.pathname === to ? "bg-secondary font-semibold" : "text-muted-foreground"}`}
    >{label}</Link>
  );
  return (
    <header data-testid="nav-header" className="glass sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" data-testid="nav-brand-link" className="flex items-center gap-2">
          <img
            src="/images/brand-mark.png"
            alt="The Common Dinner"
            data-testid="nav-brand-logo"
            className="w-10 h-10 object-contain shrink-0"
          />
          <span className="font-serif text-xl hidden sm:inline">The Common Dinner</span>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {link("/", "Dashboard", "nav-dashboard-link")}
          {link("/plan", "Plan Dinner", "nav-plan-dinner-btn")}
          {link("/group", "Group", "nav-households-link")}
          {link("/restaurants", "Restaurants", "nav-restaurants-link")}
          {link("/history", "History", "nav-history-link")}
          {link("/preferences", "Preferences", "nav-my-preferences-link")}
        </nav>
        <div className="flex items-center gap-2">
          <span className="hidden sm:block text-sm text-muted-foreground">{user?.name}</span>
          <Button
            data-testid="nav-logout-btn" variant="ghost" size="sm"
            onClick={async () => { await logout(); nav("/login"); }}>
            <LogOut className="w-4 h-4 mr-1" /> Logout
          </Button>
        </div>
      </div>
    </header>
  );
}
